export default "__VITE_ASSET__cxbDou7e__"